import * as PropTypes from "prop-types";
import { isIE } from "react-device-detect";
import PlusSvg from "./plus.svg";
import PlusGreenSvg from "./plus_green.svg";
import Icon from "./Icon";

export default function PlusIcon({
  green,
  className,
  style,
  enableSmallMarginTop,
}) {
  const icon = green ? PlusGreenSvg : PlusSvg;
  const localStyle = {
    width: "1.3rem",
    height: "1.3rem",
    ...style,
  };

  if (enableSmallMarginTop) {
    localStyle.marginTop = "3px";
  }

  if (isIE) {
    localStyle.marginLeft = "3px";
  }

  return <Icon src={icon} style={localStyle} className={className} />;
}

PlusIcon.propTypes = {
  green: PropTypes.bool,
  className: PropTypes.string,
  style: PropTypes.object,
  enableSmallMarginTop: PropTypes.bool,
};

PlusIcon.defaultProps = {
  className: "",
  style: {},
};
